import {
  cloneDeep, every, filter,
  forEach, get,
  includes, indexOf,
  isArray, isEqual, isEqualWith,
  isNull,
  isObject,
  isString,
  isUndefined, map,
  orderBy,
  split,
  trim, uniqBy, uniqWith
} from "lodash-es";
import { isDefined, $parseExpr } from "@wm/core";
import { DataSetItem } from "./input/dataset-aware.component";

const ALLFIELDS = 'All Fields';

export const setPropertiesTextWidget=(widgetProps:any, newVal:string = 'text', scope?:any)=> {
  var datavalueObj = widgetProps.datavalue || widgetProps.defaultvalue;
  if (widgetProps.step) {
    widgetProps.step.show = widgetProps.minvalue.show = widgetProps.maxvalue.show = false;
  }
  if (widgetProps.placeholder) {
    widgetProps.placeholder.show = true;
    if (widgetProps.maxchars) {
      widgetProps.maxchars.show = true;
    }
    if (widgetProps.updateon) {
      widgetProps.updateon.show = true
    }
  }
  if (widgetProps.displayformat) {
    widgetProps.displayformat.show = false;
    widgetProps.showdisplayformaton.show = false;
  }
  if (widgetProps.updatedelay) {
    widgetProps.updatedelay.show = true;
  }
  if (datavalueObj) {
    datavalueObj.type = (newVal === 'date') ? newVal : 'string';
  }
  switch (newVal) {
    case 'text':
      if (widgetProps.displayformat) {
        widgetProps.displayformat.show = true;
      }
      if (widgetProps.showdisplayformaton) {
        widgetProps.showdisplayformaton.show = scope && scope.displayformat ? true : false;
      }
      break;
    case 'number':
      widgetProps.step.show = widgetProps.minvalue.show = widgetProps.maxvalue.show = true;
      widgetProps.placeholder.show = true;
      if (widgetProps.maxchars)
      widgetProps.maxchars.show = false;
      break;
    case 'date':
    case 'datetime-local':
    case 'month':
    case 'time':
    case 'week':
      widgetProps.step.show = widgetProps.minvalue.show = widgetProps.maxvalue.show = true;
      widgetProps.placeholder.show = false;
      if (widgetProps.maxchars)
        widgetProps.maxchars.show = false;
      break;
    case 'color':
      widgetProps.updateon.show = widgetProps.updatedelay.show = false;
      widgetProps.placeholder.show = false;
      if (widgetProps.maxchars)
        widgetProps.maxchars.show = false;
      break;
  }
}

export const setPropertiesDynamicAccordion = (widgetProps: any, newVal: string, scope?: any) => {
  if (widgetProps.addchild) {
    widgetProps.addchild.show = (newVal === 'dynamic')? false: true;
  }
  if (widgetProps.nodatamessage && widgetProps.dataset) {
    widgetProps.nodatamessage.show = widgetProps.dataset.show = (newVal === 'dynamic')? true: false;
  }
}

export  const setPropertiesdisplayformat = (widgetProps: any, newVal: string) => {
  if (widgetProps.showdisplayformaton) {
    widgetProps.showdisplayformaton.show = newVal ? true : false;
  }
}

export const hideOrShowProperties = (widgetProps: any, properties: any, show: boolean) => {
  forEach(properties,(property: string)=>{
    widgetProps[property].show = show;
  })
}

export const getOrderedDataset = (dataSet: any, orderby: string, innerItem?: string) => {
  if (!orderby) {
    return cloneDeep(dataSet);
  }

  // The order by only works when the dataset contains list of objects.
  const items = orderby.split(','),
    fields: any = [],
    directions: any = [];
  items.forEach(obj => {
    const item = obj.split(':');
    fields.push(innerItem ? innerItem + '.' + item[0] : item[0]);
    directions.push(item[1]);
  });
  return orderBy(dataSet, fields, directions);
};

export const convertDataToObject = (dataResult: any) => {
  if (isString(dataResult)) {
    dataResult = split(dataResult, ',').map(str => str.trim());
  }

  return dataResult;
};

export const transformDataWithKeys = (dataSet: any) => {
  const data: DataSetItem[] = [];
  // if the dataset is instance of object (not an array) or the first item in the dataset array is an object,
  // then we extract the keys from the object and prepare the dataset items.
  if (isObject(dataSet[0]) || (isObject(dataSet) && !(dataSet instanceof Array))) {
    // getting keys of the object
    const objectKeys = Object.keys(dataSet[0] || dataSet);
    forEach(objectKeys, (objKey, index) => {
      data.push({
        key: objKey,
        label: objKey,
        value: objKey,
        index: index + 1
      });
    });
  }

  return data;
};

export const transformFormData = (context: any, dataSet: any, dataField: string = '', displayOptions?: any, startIndex?: number, scope?: any): Array<DataSetItem> => {
  const data: any = [];
  if (!dataSet) {
    // return;
  }

  dataSet = convertDataToObject(dataSet);

  // startIndex is the index of the next new item.
  if (isUndefined(startIndex)) {
    startIndex = 1;
  }

  if (isString(dataSet)) {
    dataSet = dataSet.split(',').map(str => str.trim());
    dataSet.forEach((option: any, index: any) => {
      const dataSetItem = {
        key: option,
        value: option,
        label: (isDefined(option) && option !== null) ? option.toString() : '',
        index: startIndex + index
      };
      setGroupbyKey(scope, context, dataSetItem, 'value');
      data.push(dataSetItem);
    });
  } else if (isArray(dataSet) && !isObject(dataSet[0])) { // array of primitive values only
    dataSet.forEach((option: any, index: any) => {
      const dataSetItem = {
        key: option,
        value: option,
        label: (isDefined(option) && option !== null) ? option.toString() : '',
        index: startIndex + index
      };
      setGroupbyKey(scope, context, dataSetItem, 'value');
      data.push(dataSetItem);
    });
  } else if (!(dataSet instanceof Array) && isObject(dataSet)) {
    const i = 0;
    forEach(dataSet, (value, key) => {
      const dataSetItem: any = {
        key: trim(key),
        value: key,
        label: (isDefined(value) && value !== null) ? value : '',
        index: startIndex,
        dataObject: dataSet
      };
      setGroupbyKey(scope, context, dataSetItem, 'value');
      data.push(dataSetItem);
    });
  } else {
    if (!dataField) { // consider the datafield as 'ALLFIELDS' when datafield is not given.
      dataField = ALLFIELDS;
    }
    dataSet.forEach((option: any, index: any) => {
      const key = dataField === ALLFIELDS ? startIndex + index : getObjValueByKey(option, dataField);
      // Omit all the items whose datafield (key) is null or undefined.
      if (!isUndefined(key) && !isNull(key)) {
        const label = getEvaluatedData(option, {
          field: displayOptions.displayField,
          expression: displayOptions.displayExpr
        }, context);
        const dataSetItem = {
          key: key,
          label: (isDefined(label) && label !== null) ? label.toString() : '',
          value: dataField === ALLFIELDS ? option : key,
          dataObject: option, // represents the object when datafield is ALLFIELDS. This is used as innerItem while grouping the datasetItems.
          index: startIndex + index
        };
        if (displayOptions.displayImgSrc) {
          (dataSetItem as any).imgSrc = getEvaluatedData(option, {
            expression: displayOptions.displayImgSrc,
          }, context);
        }
        setGroupbyKey(scope, context, dataSetItem, 'dataObject');
        data.push(dataSetItem);
      }
    });
  }
  return data;
};

// This function is used to set the groupby field for search/autocomplete
const setGroupbyKey = (scope: any, context: any, dataSetItem: any, innerItem: any) => {
  // if (scope && isSearchWidget(scope.widgetType)) {
  //   if (scope.groupby) {
  //     if (includes(scope.groupby, '(')) {
  //       //[Todo-CSP]: can generate expr fn in page based on groupby property on widget
  //       const groupDataByUserDefinedFn = $parseEvent(scope.groupby);
  //       (dataSetItem as any).groupby = groupDataByUserDefinedFn(context, {'row': dataSetItem.dataObject || dataSetItem});
  //     } else {
  //       (dataSetItem as any).groupby = groupDataByField(scope.groupby, scope.match, innerItem, scope.dateformat, scope.datePipe, scope.appDefaults, dataSetItem);
  //     }
  //   } else {
  //     (dataSetItem as any).groupby = '';
  //   }
  // }
};

export const getEvaluatedData = (dataObj: any, options: any, context?: any) => {
  let expressionValue;
  const field = options.field,
    expr = options.expression,
    bindExpr = options.bindExpression;

  // if key is bound expression
  if (bindExpr) {
    // remove 'bind:' prefix from the boundExpressionName
    expressionValue = bindExpr.replace('bind:', '');

    // For bind expression passing the last argument that the object of dataset item.
    // Note: For parse expression we are sending dataObj with the propery name "__1", we used the same propery to send the last argument as dataset item
    if (checkIsCustomPipeExpression(expressionValue)) {
      expressionValue = expressionValue + ': __1';
    }
    // parse the expressionValue for replacing all the expressions with values in the object
    expressionValue = getUpdatedExpr(expressionValue);
  } else {
    expressionValue = expr ? expr : field;
  }

  // Handling field name with special charecters
  // Ex: field = "f name"
  if (!bindExpr && !expr) {
    return get(dataObj, field);
  }

  return $parseExpr(expressionValue)(context, Object.assign({}, dataObj, {__1: dataObj}));
};


export const checkIsCustomPipeExpression = function (exp: any) {
  let customRegEx = /(custom(\s*:))/g;
  let matches = exp.match(customRegEx);
  return matches && matches.length;
}

export const getObjValueByKey = (obj: any, strKey: string) => {
  /* check for the key-string */
  if (strKey) {
    let val: any;
    /* convert indexes to properties, so as to work for even 'key1[0].child1'*/
    strKey.replace(/\[(\w+)\]/g, '.$1').split('.').forEach(key => {
      // If obj is null, then assign val to null.
      val = (val && val[key]) || (isNull(obj) ? obj : obj[key]);
    });
    return val;
  }
  return obj;
};

const getUpdatedExpr = (expr: string) => {
  let updated = '', ch, next, i, j, matchCh, matchCount, isQuotedStr, subStr, isQuotedStrEvaluated;

  expr = expr.replace(/\$\[data\[\$i\]/g, '$[__1');

  for (i = 0; i < expr.length; i++) {
    ch = expr[i];
    next = expr[i + 1];

    /**
     * if the expression starts with $[, check the next(ch) character,
     *    if ch is a quote(', ") change the expr to __[
     *    if ch is a whiteSpace, remove it
     *    else remove $[
     */
    if (ch === '$' && next === '[') {
      matchCount = 1;
      isQuotedStrEvaluated = false;
      isQuotedStr = false;

      for (j = i + 2; j < expr.length; j++) {

        matchCh = expr[j];

        if (matchCh === ' ') {
          continue;
        }

        if (!isQuotedStrEvaluated) {
          isQuotedStr = expr[j] === '"' || expr[j] === '\'';
          isQuotedStrEvaluated = true;
        }

        if (matchCh === '[') {
          matchCount++;
        } else if (matchCh === ']') {
          matchCount--;
        }

        if (!matchCount) {
          subStr = expr.substring(i + 2, j);
          if (isQuotedStr) {
            updated += '__1[' + subStr + ']';
          } else {
            updated += subStr;
          }

          break;
        }
      }
      i = j;
    } else {
      updated += ch;
    }
  }

  return updated;
};

export const extractDataAsArray = (data: any) => {

  if (isUndefined(data) || isNull(data) || trim(data) === '') {
    return [];
  }

  if (isString(data)) {
    data = split(data, ',').map(str => str.trim());
  }

  if (!isArray(data)) {
    data = [data];
  }

  return data;
};

export const getUniqObjsByDataField = (data: Array<any>, dataField: string, displayField: string, allowEmptyFields?: boolean) => {
  let uniqData;
  let ALLFIELDS;
  const isAllFields = dataField === ALLFIELDS;

  uniqData = isAllFields ? uniqWith(data, isEqual) : uniqBy(data, 'key');

  if (!displayField || allowEmptyFields) {
    return uniqData;
  }

  // return objects having non empty datafield and display field values.
  return filter(uniqData, (obj) => {
    if (isAllFields) {
      return trim(obj.label);
    }
    return trim(obj.key) && trim(obj.label);
  });
};

export const isEqualWithFields = (obj1: any, obj2: any, compareBy: any) => {
  // compareBy can be 'id' or 'id1, id2' or 'id1, id2:id3'
  // Split the compareby comma separated values
  let _compareBy = isArray(compareBy) ? compareBy : split(compareBy, ',');

  _compareBy = map(_compareBy, trim);

  return isEqualWith(obj1, obj2, function (o1, o2) {
    return every(_compareBy, function (cb) {
      let cb1, cb2, _cb;

      // If compareby contains : , compare the values by the keys on either side of :
      let compareBySeparator;
      if (indexOf(cb, compareBySeparator) === -1) {
        cb1 = cb2 = trim(cb);
      } else {
        _cb = split(cb, compareBySeparator);
        cb1 = trim(_cb[0]);
        cb2 = trim(_cb[1]);
      }

      return get(o1, cb1) === get(o2, cb2);
    });
  });
};

export const setListClass = (activeWidget: any) => {
  let temp = '';
  if (activeWidget.itemsperrow) {
    if(activeWidget.itemsperrow === "auto") {
      activeWidget.itemsPerRowClass = "";
    } else if (isNaN(parseInt(activeWidget.itemsperrow, 10))) {
      // handling itemsperrow containing string of classes
      split(activeWidget.itemsperrow, ' ').forEach((cls: string) => {
        const keys = split(cls, '-');
        cls = `${keys[0]}-${(12 / parseInt(keys[1], 10))}`;
        temp += ` col-${cls}`;
      });
      activeWidget.itemsPerRowClass = temp.trim();
    } else {
      // handling itemsperrow having integer value.
      activeWidget.itemsPerRowClass = `col-xs-${(12 / parseInt(activeWidget.itemsperrow, 10))}`;
    }
  } else { // If itemsperrow is not specified make it full width
    activeWidget.itemsPerRowClass = 'col-xs-12';
  }
};

export const setDeviceDisplayOnWidget = (activeWidget: any) => {
  let displayVal;
  if (!isDefined(activeWidget.pcDisplay)) {
    displayVal = activeWidget.$attrs.get('pcdisplay');
    activeWidget.pcDisplay = isDefined(activeWidget.pcdisplay) ? (activeWidget.pcdisplay === 'true') : (displayVal ?  displayVal === 'true': true);
  }
  if (!isDefined(activeWidget.mobileDisplay)) {
    displayVal = activeWidget.$attrs.get('mobiledisplay');
    activeWidget.mobileDisplay = isDefined(activeWidget.mobiledisplay) ? (activeWidget.mobiledisplay === 'true') : (displayVal ?  displayVal === 'true': true);
  }
  if (!isDefined(activeWidget.tabletDisplay)) {
    displayVal = activeWidget.$attrs.get('tabletdisplay');
    activeWidget.tabletDisplay = isDefined(activeWidget.tabletdisplay) ? (activeWidget.tabletdisplay === 'true') : (displayVal ?  displayVal === 'true': true);
  }
}

export const setDisplayFlags = (cols: any) => {
  forEach(cols, (colDef: any) => {
    if (!isDefined(colDef.pcDisplay)) {
      colDef.pcDisplay = isDefined(colDef.pcdisplay) ? (colDef.pcdisplay === 'true') : true;
    } else if (isDefined(colDef.pcdisplay)) {
      colDef.pcdisplay = undefined;
    }
    if (!isDefined(colDef.mobileDisplay)) {
      colDef.mobileDisplay = isDefined(colDef.mobiledisplay) ? (colDef.mobiledisplay === 'true') : true;
    } else if (isDefined(colDef.mobiledisplay)) {
      colDef.mobiledisplay = undefined;
    }
    if (!isDefined(colDef.tabletDisplay)) {
      colDef.tabletDisplay = isDefined(colDef.tabletdisplay) ? (colDef.tabletdisplay === 'true') : true;
    } else if (isDefined(colDef.tabletdisplay)) {
      colDef.tabletdisplay = undefined;
    }
  });
}

export const getFormFieldClass = (itemsperrow: any) => {
  let temp = '';
  if (itemsperrow) {
    if (isNaN(parseInt(itemsperrow, 10))) {
      // handling itemsperrow containing string of classes
      split(itemsperrow, ' ').forEach((cls: string) => {
        const keys = split(cls, '-');
        cls = `${keys[0]}-${(12 / parseInt(keys[1], 10))}`;
        temp += ` col-${cls}`;
      });
      return temp.trim();
    } else {
      // handling itemsperrow having integer value.
      return `col-xs-${(12 / parseInt(itemsperrow, 10))}`;
    }
  } else { // If itemsperrow is not specified make it full width
    return 'col-xs-12';
  }
};
